import React from 'react';
import { observer } from 'mobx-react-lite';
import { ThemeProvider } from 'styled-components';
import { themeState } from 'styleguide/theme';
import { stores } from 'state/stores';
import { LoadingSpinner } from './LoadingSpinner';

interface Props {
  children: React.ReactNode;
}

export const BootstrapLoadingWrapper = observer(({ children }: Props) => {
  if (!stores.lifecycle.isBootstrapped) {
    return <LoadingSpinner backgroundColor={themeState.current.background} />;
  }

  return <ThemeProvider theme={themeState.current}>{children}</ThemeProvider>;
});
